import type { AuthenticatedUser } from '@frameio/graphql-client/generated';
import { Avatar, Box, Chip, theme } from '@frameio/vapor';
import type { ThemeColorsBackground } from '@frameio/vapor-theme';

type UserSingleFieldMatchProps = {
  user: AuthenticatedUser;
};

export const UserSingleFieldMatch = ({ user }: UserSingleFieldMatchProps) => (
  <Box paddingY={2}>
    <Chip
      avatar={
        <Avatar
          alt={user?.name ?? ''}
          background={user?.avatarColor as ThemeColorsBackground}
          size={16}
          src={user?.profileImage?.image64 ?? ''}
        />
      }
      size="small"
      style={{ paddingLeft: theme.spaces[2] }}
    >
      {user?.name}
    </Chip>
  </Box>
);
